import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {white, darkGray} from '@modifi/colors'
import {Container} from '@modifi/ui'

import {colorMap} from '../common'

type TestimonialContainerProps = {
  backgroundColor?: string
}

export const TestimonialContainer = styled(Container)<TestimonialContainerProps>`
  overflow: hidden;
  ${({backgroundColor}): FlattenSimpleInterpolation | string =>
    backgroundColor && colorMap?.[backgroundColor]
      ? css`
          background-color: ${colorMap?.[backgroundColor]};
        `
      : ''}
`

export const TestimonialContentContainer = styled(Container)``

type TestimonialCardContentProps = {
  isActive?: boolean
  containerWidth: number
  numberOfCards: number
  isFirstCard: boolean
  isLastCard: boolean
}

const cardSize = (props: TestimonialCardContentProps): FlattenSimpleInterpolation => {
  if (props.numberOfCards === 1) {
    // subtract margins
    return css`
      width: ${props.containerWidth - 16}px;
    `
  }
  return css`
    width: ${(props.containerWidth - 40 * props.numberOfCards) / props.numberOfCards}px;
  `
}

export const TestimonialCardContent = styled.div<TestimonialCardContentProps>`
  min-height: 218px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  border-radius: 6px;
  transition: background-color 200ms, color 200ms;
  background-color: ${white};
  color: ${darkGray};
  box-shadow: 3px 4px 16px rgba(23, 61, 108, 0.11);
  margin-left: 8px;
  margin-right: 8px;
  ${(p): string => (p.isFirstCard && p.numberOfCards > 1 ? 'margin-left: 0;' : '')}
  ${(p): string => (p.isLastCard && p.numberOfCards > 1 ? 'margin-right: 0;' : '')}
  ${cardSize}

  & > p {
    margin: 0;
    white-space: normal;
  }
`

export const TestimonialAuthor = styled.div`
  margin-top: 24px;
  display: flex;

  & > img {
    width: 50px;
    height: 50px;
    margin-right: 16px;
  }

  & > span {
    font-weight: 600;
    margin: 8px 0;
    white-space: initial;
  }
`
